import React, { useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";

const ResetPasswordModal = ({
  visible,
  onClose,
  userId,
  isAdmin, // boolean: true for admin, false for student
}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const headers = {
        "Content-Type": "application/json",
        "HeaderKey": config.HeaderKey,
        // If you use Bearer token, you can add it here:
        // "Authorization": `Bearer ${yourToken}`,
      };

      if (isAdmin) {
        // Admin: oldPassword required, call ResetAdminPassword
        await axios.post(
          config.apiBaseUrl + "/api/users/ResetAdminPassword",
          {
            userId,
            oldPassword: values.oldPassword,
            newPassword: values.newPassword,
          },
          {
            headers,
            withCredentials: true,
          }
        );
      } else {
        // Student: only newPassword, call ResetStudentPassword
        await axios.post(
          config.apiBaseUrl + "/api/users/ResetStudentPassword",
          {
            userId,
            newPassword: values.newPassword,
          },
          {
            headers,
            withCredentials: true,
          }
        );
      }

      toast.success(<p dir="rtl" className="font-custom">رمز عبور با موفقیت تغییر کرد</p>, { autoClose: 1000 });

      form.resetFields();
      onClose();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(<p dir="rtl" className="font-custom">{error.response.data.message}</p>, { autoClose: 1000 });
        message.error(error.response.data.message);
      } else if (error.errorFields) {
        // Validation error, do nothing
      } else {
        console.log(error.response.data)
        if (error.response.data == "Password was wrong") {
          toast.error(<p dir="rtl" className="font-custom">رمز عبور وارد شده اشتباه است</p>, { autoClose: 1000 });

        }else if(error.response.data === "You dont have access to reset admin password"){
          toast.error(<p dir="rtl" className="font-custom">رمز عبور ادمین به این صورت تغییر نمی‌کند!</p>, { autoClose: 1000 });

        } else {

          toast.error(<p dir="rtl" className="font-custom">خطا در انجام عملیات</p>, { autoClose: 1000 });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      footer={null}
      centered
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOk}
        style={{ textAlign: "center" }}
      >
        {isAdmin && (
          <Form.Item
            name="oldPassword"
            label={<span className="font-custom text-right block w-full">رمز عبور قبلی</span>}
            rules={[{ required: true, message: "لطفا رمز عبور قبلی خود را وارد کنید" }]}
          >
            <Input.Password placeholder="Enter old password" />
          </Form.Item>
        )}
        <Form.Item
          name="newPassword"
            label={<span className="font-custom text-right block w-full">رمز عبور جدید</span>}
          rules={[
            { required: true, message: "لطفا رمز عبور جدید را وارد کنید" },
            { min: 6, message: "رمز عبور باید حداقل شامل 6 کاراکتر باشد" },
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
            label={<span className="font-custom text-right block w-full">تکرار رمز عبور جدید</span>}
          dependencies={["newPassword"]}
          className="font-custom"
          rules={[
            { required: true, message: "لطفا تکرار رمز عبور را وارد کنید" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("رمز عبور مطابقت ندارد")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
          >
            {<span className="font-custom">بازنشانی رمز عبور</span>}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ResetPasswordModal;